import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  disabledIcon: {
    opacity: 0.3,
  },
  deactivateUser: {
    opacity: 0.5,
  },
  responseIconNotif: {
    position: "absolute",
    "&:after": {
      position: "absolute",
      top: -23,
      right: -22,
      width: 7,
      height: 7,
      borderRadius: "50%",
      background: "#EF7713",
      border: "1px solid white",
      content: '""',
    },
  },
}));
